// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PX_6","label":"styles_label__2uxMw"};